import React from "react";
import { Button } from "../../../components/ui/button";
import { Dialog, DialogContent, DialogHeader } from "../../../components/ui/dialog";
import { postInitiaizeSemanticSearch } from "../../utils/api";

interface IProps {
  semanticSearchInitializationState: "OPEN" | "RUNNING" | "ERROR" | "SUCCESS" | undefined
  setSemanticSearchInitializationState: React.Dispatch<
    React.SetStateAction<"OPEN" | "RUNNING" | "ERROR" | "SUCCESS" | undefined>
  >;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function SemanticSearchInitialization(props: IProps) {
  const [state, setState] = React.useState("idle");
  const statusText = {
    OPEN: "Semantic Search isn't initialized",
    RUNNING:
      "Initializing Semantic Search! It can take some time. Please have a coffee and come back",
    ERROR: "Oops, Semantic search initialization failed.",
    FAILED: "Oops, Semantic search initialization failed.",
    SUCCESS:
      "Semantic Search is already initialized. You can start searching. Happy Searching",
  };

  const initializeSemanticSearch = () => {
    setState("running");
    postInitiaizeSemanticSearch()
      .then(() => {
        //props.setSemanticSearchInitializationState("SUCCESS");
        setState("success");
        props.setOpen(false)
      })
      .catch(() => {
        setState("error");
      });
  };

  return (
    <Dialog open={props.open} onOpenChange={(val) => props.setOpen(val)}>
      <DialogContent className="bg-white">
        <DialogHeader>
          <p className="text-xl font-md text-skin-base">
            {props.semanticSearchInitializationState && statusText[props.semanticSearchInitializationState]}
          </p>
        </DialogHeader>
        <Button
          className="flex items-center gap-2 "
          disabled={props.semanticSearchInitializationState == "RUNNING" || state == "running" || props.semanticSearchInitializationState == "SUCCESS"}
          loading={props.semanticSearchInitializationState == "RUNNING" || state == "running"}
          onClick={initializeSemanticSearch}
        >
          Initialize
        </Button>
      </DialogContent>
    </Dialog>
  );
}
